import React, { Component } from 'react';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class Test220326 extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterThursday2'>
      <img className='logo' src={logo}></img>
      <br />
      <h3>Examination 22/03/2026 Candidates(Bangkok)</h3>
      <br />
      <br />

        <div><Link to='/conduct-amornpont'>1. AAT 2188  MR.AMORNPON TEEPANART(2DAN)---Trying for 3DAN</Link></div>
        <br />
        <div><Link to='/conduct-nitchakarnt'>2. AAT 7759  CPO1.NITCHAKARN THAWORNKAN(SHODAN-HO)---Trying for SHODAN</Link></div>
        <br />
        <div><Link to='/conduct-chaiyutv'>3. AAT  8017  MAJ.GEN. CHAIYUT VAJIRAVARABHAKTI(SHODAN-HO)---Trying for SHODAN</Link></div>
        <br />
        <div><Link to='/conduct-suteed'>4. AAT  8023  COL.SUTEE DUANGTOON(SHODAN-HO)---Trying for SHODAN</Link></div>
        <br />
        <div><Link to='/conduct-niwats'>5. ATT  6670  MR.NIWAT SEESANGNGAM(2KYU)---Trying for 1KYU</Link></div>
        <br />
        <div><Link to='/conduct-niratb'>6. AAT 6571  MR.NIRAT BOONYASAWET(5KYU)---Trying for 4KYU</Link></div>
        <br />
        <div><Link to='/conduct-napasanunv'>7. ATT  7951  MS.NAPASANUN VONGVIVAT(7KYU)---Trying for 6KYU</Link></div>
        <br />
        <div><Link to='/conduct-issariyapar'>8. ATT  7952  MR.ISSARIYAPA ROOPSUWANNAKUL(7KYU)---Trying for 6KYU</Link></div>
        <br />
        <div><Link to='/conduct-karnts'>9. AAT  8007  MR.KARNT SRISUWAN(8KYU)---Trying for 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-pakawadn'>10. AAT  8008  MR.PAKAWAD NANTAJURAPLO(8KYU)---Trying for 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-archirawishp'>11. AAT  8009  MR.ARCHIRAWISH PAKCHOTIPONG(8KYU)---Trying for 7KYU</Link></div>
        <br />
        <div><Link to='/conduct-vunqt'>12. AAT  8021  MS.VU NGUYEN QUYNH TRAM(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-nutchan'>13. ATT  7955  MS.NUTCHA  NAKAEW(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-matsakaj'>14. ATT  8002  MR.MATSAKA JANSAWANG(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-patawank'>15. ATT  8050  MS.PATTAWAN KANPLIEN(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-chakchaia'>16. AAT  8022  1st LT.CHAKCHAI ANUPONGPAT(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-kosinm'>20. AAT 8051  MR.KOSIN MUNGCHAROEN(9KYU)---Trying for 8KYU</Link></div>
        <br />
        <div><Link to='/conduct-praphatpongy'>17. AAT  8038  MR.PRAPHATPONG  YOODEE(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-naras'>18. AAT  8040  MR.NARA  SINGHSATHITSUK(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-narat'>19. AAT  8033  MS.NARA TAKIGUCHI(10KYU)---Trying for 9KYU</Link></div>
        <br />
        <div><Link to='/conduct-cheiax'>21. AAT  8034  MR.CHEIA  XAVIER(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-pawatchakornh'>22. AAT 8052  MR.PAWATCHAKORN HASUNHA(WB)---Trying for 10KYU</Link></div>
        <br />
        <div><Link to='/conduct-jasona'>23. AAT 8053  MR.JASON ANG(WB)---Trying for 10KYU</Link></div>
        <br />
        <div>
          Thailand's Aikido Association Registration...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default Test220326;
